// extracted by mini-css-extract-plugin
export default {"loader":"SmallLoader_loader__-wfmO","rotation":"SmallLoader_rotation__nVA39"};